import { MeshStandardMaterialParameters, TextureLoader, Vector2 } from 'three'

const textureLoader = new TextureLoader()

const AsphaltMaterialProps = {
  aoMap: textureLoader.load(`${process.env.PUBLIC_URL}/assets/textures/Asphalt/Asphalt_004_ambientOcclusion.jpg`),
  map: textureLoader.load(`${process.env.PUBLIC_URL}/assets/textures/Asphalt/Asphalt_004_basecolor.jpg`),
  displacementMap: textureLoader.load(`${process.env.PUBLIC_URL}/assets/textures/Asphalt/Asphalt_004_height.png`),
  normalMap: textureLoader.load(`${process.env.PUBLIC_URL}/assets/textures/Asphalt/Asphalt_004_normal.jpg`),
  roughnessMap: textureLoader.load(`${process.env.PUBLIC_URL}/assets/textures/Asphalt/Asphalt_004_roughness.jpg`),
  metalness: 0,
  roughness: 0,
} as MeshStandardMaterialParameters
AsphaltMaterialProps.displacementScale = 0
AsphaltMaterialProps.normalScale = new Vector2(1, 1)


export default AsphaltMaterialProps